import { atom } from 'jotai';

export const messageLibraryEntryActionsAtom = atom();
messageLibraryEntryActionsAtom.debugLabel = 'messageLibraryEntryActions';

export const messageAwaitingApprovalActionsAtom = atom();
messageAwaitingApprovalActionsAtom.debugLabel =
  'messageAwaitingApprovalActions';

export const messageMatchEventsAtom = atom();
messageMatchEventsAtom.debugLabel = 'messageMatchEvents';

export const messageMoveVideoActionAtom = atom();
messageMoveVideoActionAtom.debugLabel = 'messageMoveVideoAction';

export const messageReviewLibraryEntryActionAtom = atom();
messageReviewLibraryEntryActionAtom.debugLabel =
  'messageReviewLibraryEntryAction';

export const messagePlaylistActionAtom = atom();
messagePlaylistActionAtom.debugLabel = 'messagePlaylistAction';

export const messageSettingsAtom = atom();
messageSettingsAtom.debugLabel = 'messageSettings';

export const messageDataSyncActionAtom = atom();
messageDataSyncActionAtom.debugLabel = 'messageDataSyncAction';

export const messageOffsetAlignmentVerificationAtom = atom();
messageOffsetAlignmentVerificationAtom.debugLabel =
  'messageOffsetAlignmentVerification';
